import React from 'react';
import { Trans } from 'react-i18next';
import classes from './Header.module.scss';
import DrawerMenu from '../DrawerMenu/DrawerMenu';
import { useDispatch, useSelector } from 'react-redux';
import { setResetChat, setWidgetIsOpen, setDrawerIsOpen, setPrechatStatus,setAlertIsOpen } from '../../store/actions/general';
import { resetGenesysSession } from '../../store/actions/genesys';
import { setMessages, setQuickResponses, setMode } from '../../store/actions/messages';
import MuiPlaceholder from '../controls/MuiPlaceholder/MuiPlaceholder';
import Tooltip from '../controls/Tooltip/Tooltip';
import { resetPrechat } from '../../store/actions/prechat';
import type { HeaderProps } from '../../types/components.props';
import type { RootState } from '../../types/redux';
import { getUiConfig, isChatEnded } from '../../utils/config';

const Header: React.FC<HeaderProps> = ({socket}) => {
  const { showForm, isPrechatSubmitted } = useSelector((state: RootState) => state.prechat);
  const { muiFontLoaded, prechatStatus } = useSelector((state: RootState) => state.general);
  const dispatch = useDispatch();
  const uiConfig = getUiConfig();

  const minimizeWidget = () => {
    dispatch(setWidgetIsOpen(false));
    if (isChatEnded()) {
      dispatch(resetGenesysSession());
      dispatch(setMessages([]));
      dispatch(setMode('bot'));
      dispatch(setResetChat(false))
      dispatch(setQuickResponses([]));
      dispatch(setAlertIsOpen(true));
      dispatch(setPrechatStatus(true));
      dispatch(resetPrechat());
    }
  };

  const closeWidget = () => {
    dispatch(setDrawerIsOpen(false));

    if (isChatEnded()) {
      dispatch(setWidgetIsOpen(false));
      dispatch(resetGenesysSession());
      dispatch(setMessages([]));
      dispatch(setMode('bot'));
      dispatch(setResetChat(false))
      dispatch(setQuickResponses([]));
      dispatch(setPrechatStatus(true));
      dispatch(resetPrechat());
    } else {
      dispatch(setResetChat(true))
    }
  };

  const backButtonHandler = () => {
    dispatch(resetPrechat());
  }

  return (
    <div className={classes.Header} style={uiConfig.header_styles?.background ?? {}}>
      <div className={classes.HeaderTitle} style={uiConfig.header_styles?.title ?? {}}>
        {prechatStatus && showForm && !isPrechatSubmitted ? 
          <div className={classes.BackIconButton} onClick={backButtonHandler}>
            <button>
                <MuiPlaceholder
                isMuiFontLoaded={muiFontLoaded}
                element={<div>arrow_back</div>}
                width={80}
                height={80}
                backgroundColor={'transparent'} />
            </button>
            Back
          </div>
          : 
          <>
          {uiConfig.header_image_url ? (
            <div className={classes.Image}>
              <div>
              <img
                src={uiConfig.header_image_url}
                alt='Logo'
                style={{
                  width: uiConfig.header_image_size,
                }}
              />
              </div>
              <div>
                <Trans i18nKey="header.title">
                  {uiConfig.header_title}
                </Trans>
                {uiConfig.header_sub_title && 
                  <>
                    <br/>
                    <Trans i18nKey="header.subTitle">
                      <span className={classes.SubTitle} style={uiConfig.header_styles?.sub_title ?? {}}>{uiConfig.header_sub_title}</span>
                    </Trans>
                  </>
                 }
              </div>
            </div>
          ) : (
            <div>
              <Trans i18nKey="header.title">
                {uiConfig.header_title}
              </Trans>
            </div>
          )} 
          </>
         }

        <div className={classes.HeaderButtons}>
          <DrawerMenu />
          <Tooltip text="Minimize">
            <button className={classes.IconButton} onClick={minimizeWidget} style={{color: uiConfig.header_styles?.icon_colors ?? undefined}}>
              <MuiPlaceholder
                isMuiFontLoaded={muiFontLoaded}
                element={<div>remove</div>}
                width={30}
                height={30}
                backgroundColor={'#eeeeee'} />
            </button>
          </Tooltip>
          <Tooltip text="End chat">
            <button className={classes.IconButton} onClick={closeWidget} style={{color: uiConfig.header_styles?.icon_colors ?? undefined}}>
              <MuiPlaceholder
                isMuiFontLoaded={muiFontLoaded}
                element={<div>close</div>}
                width={30}
                height={30}
                backgroundColor={'#eeeeee'} />
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Header;